import { NgModule } from '@angular/core';
import { EditorModule } from '@tinymce/tinymce-angular';

@NgModule({
	declarations: [],
	imports: [],
	exports: [EditorModule],
})
export class ThirdPartyModule {}
